import { render, staticRenderFns } from "./admin-log.vue?vue&type=template&id=71d0b278&"
import script from "./admin-log.vue?vue&type=script&lang=js&"
export * from "./admin-log.vue?vue&type=script&lang=js&"
import style0 from "./admin-log.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports